import styled from 'styled-components';
import theme from 'styled-theming';
var Container = styled.div.withConfig({
  displayName: "Badgestyles__Container",
  componentId: "sc-jtsqtx-0"
})(["display:inline-flex;position:relative;flex-shrink:0;vertical-align:middle;"]);
var Child = styled.div.withConfig({
  displayName: "Badgestyles__Child",
  componentId: "sc-jtsqtx-1"
})([""]);
var Badge = styled.div.withConfig({
  displayName: "Badgestyles__Badge",
  componentId: "sc-jtsqtx-2"
})(["position:absolute;display:flex;z-index:1;transition:transform 225ms cubic-bezier(0.4,0,0.2,1) 0ms;min-width:", ";width:", ";height:16px;border-radius:8px;", ";", ";background-color:", ";transform:", " translate( ", ",", " );transform-origin:", " ", ";"], theme('variant', {
  content: '16px'
}), theme('variant', {
  dot: '16px'
}), theme('horizontal', {
  left: theme('overlap', {
    circle: 'left: 14%',
    square: 'left: 0'
  }),
  right: theme('overlap', {
    circle: 'right: 14%',
    square: 'right: 0'
  })
}), theme('vertical', {
  top: theme('overlap', {
    circle: 'top: 14%',
    square: 'top: 0'
  }),
  bottom: theme('overlap', {
    circle: 'bottom: 14%',
    square: 'bottom: 0'
  })
}), theme('status', {
  "default": 'var(--dentsu-color-n100)',
  neutral: 'var(--dentsu-color-b50)',
  positive: 'var(--dentsu-color-g100)',
  warning: 'var(--dentsu-color-a100)',
  error: 'var(--dentsu-color-r100)'
}), theme('isHidden', {
  "true": 'scale(0)',
  "false": 'scale(1)'
}), theme('horizontal', {
  left: '-50%',
  right: '50%'
}), theme('vertical', {
  top: '-50%',
  bottom: '50%'
}), theme('horizontal', {
  left: '0%',
  right: '100%'
}), theme('vertical', {
  top: '0%',
  bottom: '100%'
}));
var Dot = styled.div.withConfig({
  displayName: "Badgestyles__Dot",
  componentId: "sc-jtsqtx-3"
})(["color:var(--dentsu-color-white);font-weight:var(--dentsu-font-weight-semibold);white-space:nowrap;text-align:center;font-size:", ";line-height:", ";margin:", ";padding:", ";min-width:", ";width:", ";height:", ";border-radius:", ";background-color:", ";"], theme('variant', {
  content: '9px'
}), theme('variant', {
  content: '11px'
}), theme('variant', {
  content: '2px',
  dot: 'auto'
}), theme('variant', {
  content: '0 2px',
  dot: '0px'
}), theme('variant', {
  content: '12px'
}), theme('variant', {
  dot: '8px'
}), theme('variant', {
  content: '12px',
  dot: '8px'
}), theme('variant', {
  content: '6px',
  dot: '4px'
}), theme('status', {
  "default": 'var(--dentsu-color-n600)',
  neutral: 'var(--dentsu-color-b500)',
  positive: 'var(--dentsu-color-g500)',
  warning: 'var(--dentsu-color-a500)',
  error: 'var(--dentsu-color-r500)'
}));
export var Styled = {
  Badge: Badge,
  Child: Child,
  Container: Container,
  Dot: Dot
};